import * as React from 'react'
import { Control } from 'rete'

interface LabelFieldProps {
    getValue: () => string
}

const LabelField = ({ getValue }: LabelFieldProps) => {
    // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = React.useReducer(x => x + 1, 0)

    // `getValue()` reads `node.data[key]`, which is `undefined` until the
    // node's worker first populates the summary (e.g. right after load via
    // `fromJSON`, before processing has run). Coerce to a string so we never
    // call `.replace` on undefined. `replaceAll` so every newline is
    // converted, not just the first.
    const value = getValue()
    const text = typeof value === "string" ? value : value == null ? "" : String(value)

    return (
        <div className="text-center" >{text.replace(/\n/g, '<br>')}</div>
    )

}

export class LabelControl extends Control {
    props: LabelFieldProps
    component: (props: LabelFieldProps) => JSX.Element

    constructor(key: string) {
        super(key)

        this.props = {
            getValue: this.getData.bind(this, key),
        }

        this.component = LabelField
    }

}